var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircuitId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52942 7.97428C5.46548 7.97428 6.3632 7.60689 7.0251 6.95292C7.68699 6.29896 8.05884 5.41199 8.05884 4.48714C8.05884 3.56229 7.68699 2.67533 7.0251 2.02136C6.3632 1.36739 5.46548 1 4.52942 1C3.59336 1 2.69564 1.36739 2.03374 2.02136C1.37185 2.67533 1 3.56229 1 4.48714C1 5.41199 1.37185 6.29896 2.03374 6.95292C2.69564 7.60689 3.59336 7.97428 4.52942 7.97428V7.97428Z",
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 14.9486H7.47021V20.7605H1.58789V14.9486Z",
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5768 4.48718H22.1768V17.8546H12.1768",
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitId);
export default __webpack_public_path__ + "static/media/circuit-id.359adeb655668ce9571b8b0515d6b4c1.svg";
export { ForwardRef as ReactComponent };